// component for set dangerouslySetInnerHTML text
const DangerouslyHtml = ({ children }) => <div dangerouslySetInnerHTML={{ __html: children }} />
export default DangerouslyHtml;